import { object, string } from 'yup'

export const addCarSchema = object({
  car_model: string().required('فیلد نوع خودرو الزامی است.'),
  color: string().required('فیلد رنگ خودرو الزامی است.'),
  monthly_ride: string().required('فیلد میانگین کیلومتر الزامی است.'),
  description: null,
  first: null | string().max(2, 'حداکثر تعداد کاراکتر باید 2 رقم باشد'),
  letter: null | string(),
  second: null | string().max(3, 'حداکثر تعداد کاراکتر باید 3 رقم باشد'),
  state: null | string().max(2, 'حداکثر تعداد کاراکتر باید 2 رقم باشد'),
  aras_plate:
    null |
    string()
      .min(5, 'حداقل تعداد کاراکتر باید 5 رقم باشد')
      .max(7, 'حداکثر تعداد کاراکتر باید 7 رقم باشد'),
})
